import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { TAGLINE } from "../../data/menu";

export const Ribbon = () => {
  const items = [TAGLINE, "Spaghetti", "Chicken Wings", "Baked Beans", "Fresh Every Order"];
  return (
    <div
      data-testid="marquee-ribbon"
      className="border-y border-black/20 bg-[#e63946] py-4 md:py-6"
    >
      <Marquee speed={55} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="marquee-item mx-6 md:mx-10 text-2xl md:text-4xl text-white">
            {it}
            <Star className="mx-6 md:mx-10 h-5 w-5 md:h-7 md:w-7 fill-[#ffb703] text-[#ffb703]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
